<div class="">    
    <router-outlet></router-outlet>
</div>